import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {
  IAutomationAppResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IAutomationAppResponseInstance'

export function getViaEntityAppPayload(
  viaEntity: IResponseEntity,
): IAutomationAppResponseInstance | null {
  if(viaEntity?.entityType !== EntityType.App) {
    return null
  }
  return viaEntity.payload as IAutomationAppResponseInstance
}
